import { FC } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Stepper, Step, StepLabel } from "@mui/material";

interface StepperComponentProps {
    activeStep: number;
    steps: string[];
}

const StepperComponent: FC<StepperComponentProps> = ({ activeStep, steps }) => {

  const isMobile = useMediaQuery("(max-width:550px)");

    return (
        <Stepper
            activeStep={activeStep}
            alternativeLabel={!isMobile}
            orientation={isMobile ? "vertical" : "horizontal"}
            sx={{
                mb: 4,
                "& .MuiStepIcon-root": {
                    color: "#bfa14b",
                    "&.Mui-active": { color: "#bfa14b" },
                    "&.Mui-completed": { color: "#bfa14b" }
                }
            }}
        >
            {steps.map((label) => (
                <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            ))}
        </Stepper>
    )
}

export default StepperComponent;